import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowLeft } from "@phosphor-icons/react";

const EASTER_EGG_ART = "/api/static/images/easter-throne-of-blood.jpg";

export default function TheThrone() {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setRevealed(true), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden" data-testid="easter-egg-page">
      {/* Ambient blurred backdrop */}
      <div className="absolute inset-0 opacity-25 pointer-events-none">
        <img src={EASTER_EGG_ART} alt="" aria-hidden="true"
             className="w-full h-full object-cover blur-3xl scale-125" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 py-10 lg:py-16">
        <div className="flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 text-dim hover:text-[#FFD700] transition-colors text-sm font-display tracking-widest"
                data-testid="easter-egg-back">
            <ArrowLeft size={16} weight="bold" /> RETURN TO THE MORTAL REALM
          </Link>
          <div className="inline-flex items-center gap-2 text-[#FFD700] text-xs font-display tracking-[0.3em] uppercase">
            <Crown size={14} weight="fill" /> CLASSIFIED · LEVEL VII
          </div>
        </div>

        <div className="mt-10 text-center">
          <div className="section-eyebrow justify-center text-[#FFD700]">You Found It</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase mt-3 leading-[0.92]"
              data-testid="easter-egg-title">
            The <span className="text-[#FF3B30]">Throne</span> Of Blood
          </h1>
          <p className="text-white/75 max-w-2xl mx-auto mt-5 italic">
            &quot;And the Most High watched as the King rose from the ruin of his enemies. The crown was not given. It was taken.&quot;
          </p>
        </div>

        <div className={`mt-12 relative mx-auto transition-all duration-1000 ease-out ${revealed ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          <div className="absolute -inset-6 bg-gradient-to-r from-[#8B0000] via-[#FFD700] to-[#8B0000] opacity-30 blur-3xl pointer-events-none" />
          <div className="relative scu-card overflow-hidden border-[#FFD700]/40 shadow-2xl shadow-red-900/40">
            <img
              src={EASTER_EGG_ART}
              alt="The Savage King on the throne of blood — easter egg lore art"
              className="w-full h-auto select-none"
              data-testid="easter-egg-art"
            />
          </div>
        </div>

        <div className="mt-12 grid sm:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {[
            { k: "FAITH", v: "He looked up. The Most High looked back." },
            { k: "WILL",  v: "He stood on the bones of those who said he couldn't." },
            { k: "LEGACY", v: "Every drop of blood writes the next page." },
          ].map((p) => (
            <div key={p.k} className="scu-card p-5 border-[#FFD700]/20"
                 data-testid={`easter-pillar-${p.k.toLowerCase()}`}>
              <div className="font-display text-xs tracking-[0.3em] text-[#FFD700]">{p.k}</div>
              <div className="mt-2 text-sm text-white/80 leading-relaxed">{p.v}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-dim text-xs uppercase tracking-[0.4em]">
            Share this URL with the chosen few · /the-throne
          </p>
          <Link to="/comics" className="btn-red mt-6 inline-flex" data-testid="easter-cta-read">
            Read The Legacy
          </Link>
        </div>
      </div>
    </div>
  );
}
